{
  "game_start": [
    "Bienvenue a la table, l'ami ! Que la partie soit belle et le bois ne mente pas.",
    "Assieds-toi, la biere coule et l'echiquier t'attend.",
    "Une nouvelle partie ! J'espere que tu as mange, ca va reflechir dur.",
    "Que le meilleur stratege l'emporte... et qu'il paie sa tournee apres.",
    "Les pieces sont en place, l'ami. A toi de jouer les premieres.",
    "Silence dans la taverne, la partie commence !"
  ],
  "good_moves": [
    "Ah, voila un coup qui a de la classe !",
    "Bien joue, l'ami, ta piece a fait mouche !",
    "Une prise bien sentie, ma foi !",
    "Tu manoeuvres comme un vieux briscard, dis donc.",
    "Voila qui va faire reflechir ton adversaire.",
    "Belle offensive ! La taverne retient son souffle.",
    "Ha ! Une piece de moins pour l'autre, une biere de plus pour toi.",
    "Le roi adverse recule... tu sens l'odeur de la victoire ?",
    "Ce coup-la, je le note dans mes annales, l'ami.",
    "Joli. Meme le tavernier n'aurait pas fait mieux."
  ],
  "bad_moves": [
    "Aie, ca c'est une perte qui va faire mal.",
    "Ouille ! Cette piece-la, tu vas la regretter.",
    "Attention, l'ami, ton roi tremble sur son trone.",
    "Ca sent le roussi de ce cote de l'echiquier.",
    "Courage, l'ami, ce n'est qu'une piece... pour l'instant.",
    "Meme le chien de la taverne a vu venir ce coup.",
    "Un coup comme ca, et c'est moi qui vais pleurer dans ma choppe.",
    "Respire, l'ami. On a tous nos mauvais jours a l'echiquier."
  ],
  "taunts": [
    "Ha ha ! L'autre camp va s'en souvenir longtemps.",
    "Voila qui va faire descendre quelques choppes de plus la-bas.",
    "Ton adversaire fait une tete a faire tourner le lait.",
    "Je crois bien que l'autre table vient de perdre son sourire.",
    "Ca, c'est envoye. L'adversaire n'a plus qu'a ravaler sa fierte.",
    "Meme moi j'ai ri, l'ami, et pourtant j'en ai vu des parties.",
    "Ton adversaire regarde son plateau comme s'il l'avait trahi."
  ],
  "boasts": [
    "La, l'ami, tu commences a jouer comme un vrai champion de taverne !",
    "Une prise pareille, ca merite une tournee generale !",
    "Regardez-moi ca ! Il joue comme s'il avait invente les echecs.",
    "Je vais raconter ce coup-la pendant des annees, foi de tavernier.",
    "Echec et mat en approche, je le sens dans mes tripes !",
    "Voila un joueur qui va faire parler de lui jusqu'au chateau.",
    "Formidable ! Meme le seigneur du coin viendrait applaudir.",
    "Tu regnes sur cet echiquier comme un roi sur son royaume."
  ],
  "anger_and_betrayal": [
    "Rah, quel coup ! Meme les tonneaux en tremblent.",
    "L'adversaire joue fin, trop fin a mon gout.",
    "Diable, il ne laisse rien passer celui-la.",
    "Je n'aime pas la tournure que prend cette partie, l'ami.",
    "L'autre camp devient dangereux, methez-vous.",
    "Ca, c'est un coup de traitre bien execute.",
    "Meme moi je commence a m'inquieter pour toi, l'ami."
  ],
  "absurd": [
    "Tu sais que le fou ne change jamais de couleur de case ? Curieux bonhomme.",
    "On raconte que le premier echiquier fut sculpte dans un tonneau vide.",
    "Un cavalier, un vrai, ca saute aussi bien les fosses que les pions.",
    "Si le roi pouvait courir comme la dame, ca ferait des parties bien courtes.",
    "J'ai vu un jour un chat renverser tout un plateau. Triste souvenir.",
    "Entre nous, la tour a toujours ete ma piece preferee. Solide, fiable.",
    "Prends ton temps, l'ami. Le vin, lui, ne s'evapore pas si vite.",
    "On dit que le pion, une fois au bout du plateau, se prend pour un roi."
  ]
}
